<template>
    <div class="page newpage">
        <div class="_flex">
			<el-date-picker v-model="formData.name" type="date" class="w200" size="small" placeholder="时间范围"/>
			<el-input placeholder="标题" v-model="formData.name" size="small" class="w200 ml_10"/>
			<el-select v-model="formData.name" class="w200 ml_10" size="small" placeholder="编辑人">
				<el-option
				  v-for="(item,index) in [{name:'一级'},{name:'一级1'}]"
				  :key="index"
				  :label="item.name"
				  :value="index">
				</el-option>
			  </el-select>
			  <el-select v-model="formData.name" class="w200 ml_10" size="small" placeholder="类型">
				  <el-option
					v-for="(item,index) in [{name:'一级'},{name:'一级1'}]"
					:key="index"
					:label="item.name"
					:value="index">
				  </el-option>
				</el-select>
			<div class="_button nul mr_10 ml_10">筛选</div>
			<div class="_button mr_10" @click="show=true">添加</div>
			<div class="_button mr_10" @click="represShow=true">分类</div>
		</div>
		<div class="mt_20">
			<el-table :data="list" stripe :header-cell-style="{ background:'#f5f5f5'}">
			    <el-table-column prop="id" label="序号"></el-table-column>
			    <el-table-column prop="name" label="类型" ></el-table-column>
			    <el-table-column prop="name" label="标题" ></el-table-column>
			    <el-table-column prop="name" label="上传" ></el-table-column>
			    <el-table-column prop="name" label="编辑人" ></el-table-column>
			    <el-table-column prop="name" label="审核状态" ></el-table-column>
			    <el-table-column prop="name" label="浏览次数" ></el-table-column>
			    <el-table-column label="操作" width="180px">
					<div class="_flex">
						<div class="_button bag_blue p_2626 mr_5">编辑</div>
						<div class="_button bag_red p_2626">删除</div>
					</div>
			    </el-table-column>
			  </el-table>
			  <div class="mt_30 t_r">
				  <el-pagination background
                        @size-change="init"
					  :current-page="1"
                        @current-change="init"
					  :page-size="1"
					  layout="total, sizes, prev, pager, next, jumper"
					  :total="20"></el-pagination>
			  </div>
		</div>
		
		<el-dialog title="编辑/新增" :visible="show" width="600px" center @close="show=false">
		  <el-form label-position="right" label-width="80px" :model="formData" class="pr_20">
		    <el-form-item label="标题：">
		      <el-input v-model="formData.name"></el-input>
		    </el-form-item>
		    <el-form-item label="排序：">
		      <el-input v-model="formData.name"></el-input>
		    </el-form-item>
			<el-form-item label="分类：">
		      <el-select v-model="formData.name" class="w_100" placeholder="请选择">
		          <el-option
		            v-for="(item,index) in [{name:'一级'},{name:'一级1'}]"
		            :key="index"
		            :label="item.name"
		            :value="index">
		          </el-option>
		        </el-select>
		    </el-form-item>
		    <el-form-item label="内容：">
				编辑器
		    </el-form-item>
		    <el-form-item label="附件：">
				<a href="" class="mr_30">啊士大夫鬼地方sd3.pdf</a>
				<a class="el-icon-top blue f_18"></a>
				<a class="el-icon-delete c5 f_18"></a>
		    </el-form-item>
		    <div class="t_c mt_20">
				<button class="_button f_16 mr_30 nul" @click="show=false">取 消</button>
				<button class="_button f_16 b1s">确 定</button>
		    </div>
		  </el-form>
		</el-dialog>
		
		<el-dialog title="员工信息" :visible="represShow" width="800px" center @close="represShow=false">
		  <el-form label-position="top" label-width="90px" :model="formData" class="pr_20">
			  <el-row :gutter="30">
			    <el-col :span="16">
					<el-tabs v-model="name" type="card" @tab-click="init">
					    <el-tab-pane label="文档分类" name="1"></el-tab-pane>
					    <el-tab-pane label="通知分类" name="2"></el-tab-pane>
					    <el-tab-pane label="短息模板分类" name="3"></el-tab-pane>
					  </el-tabs>
					<div class="_scroll" style="min-height: 100px;max-height: 300px;">
						<div class="p_10 bb1se" v-for="i in 20">员工培训-{{i}}<a class="red el-icon-delete fr"></a></div>
					</div>
				</el-col>
				<div class="br1se" style="position: absolute;height: 100%;left: 68%;"></div>
			    <el-col :span="1">&nbsp;</el-col>
				<el-col :span="7">
					<div>编辑分类</div>
					<div class="mt_30 mb_10">分类名称：</div>			  
					<el-input placeholder="标题" v-model="formData.name" size="small" class="w200 ml_10"/>
				</el-col>
			  </el-row>
		    <div class="t_c mt_20">
				<button class="_button f_16 mr_30 nul" @click="represShow=false">取 消</button>
				<button class="_button f_16 b1s">确 定</button>
		    </div>
		  </el-form>
		</el-dialog>
		
    </div>
</template>
<script>
import Tip from "@/components/Tip/Tip.vue"
import * as echarts from 'echarts';
export default{
    components: {
        Tip
    },
    data(){
        return {
			name:'',
            list : [{id:1,name:'素材库'}],
			show : false,
			represShow : false,
			formData : {
				name : ''
			},
        }
    },
	mounted() {
		this.init()
	},
	methods:{
		init(){
			
		}
		
	}
}
</script>

<style  scoped>
</style> 